<template>
	<div>
		<div v-tr="'landingpage_membershippanel_explanation'" class="mia-description" />
		<div class="mia-informationTiles">
			<flip-card class="mia-tile" :icon="familyIcon"
				header-tr="membership_homeschooldiscounts_header"
				description-tr="membership_homeschooldiscounts_description"
				button-text-tr="membership_homeschooldiscounts_buttonText"
				:button-link="contactsUrl"
			/>
		</div>
	</div>
</template>
<script lang="ts">
import { Component, Prop, Vue, toNative } from "vue-facing-decorator";

import { MiaPlaza } from "../../../Reinforced.Typings";
import FlipCard from "@/Control/Vue/FlipCard.vue";

@Component({
	components: { FlipCard },
})
export class MembershipFlipTiles extends Vue {
	@Prop({ required: true }) contactsUrl!: string;
	@Prop({ required: true }) familyIcon!: MiaPlaza.Navigation.JSON.Converters.ILazySizes;
}

export default toNative(MembershipFlipTiles);
</script>
